import { observer } from "mobx-react"
import { useStore } from "@features/common"
import { htmlToTextTransform } from "@lib/html"
import { ARTICLE_PREVIEW_CLIPPATH_ID } from "@features/journal"
import FeaturedPostBorderSvg from "@assets/media/safer-dating/featured-post-border.svg"

import { SaferDatingButton } from "../atoms"

type FeaturedPostSectionProps = {
  title?: string
  description?: string
  imageSrc?: string
  buttonText: string
  buttonHref: string
  buttonHrefLang?: string
}

export const FeaturedPostSection = observer(function FeaturedPostSection({
  title,
  description,
  imageSrc,
  buttonText,
  buttonHref,
  buttonHrefLang,
}: FeaturedPostSectionProps) {
  const { ResponsiveModel } = useStore()

  if (!title || !description || !imageSrc) {
    return null
  }

  return (
    <section className="flex flex-col-reverse overflow-hidden relative bg-gray-50 px-[24px] pt-9 pb-2 tablet-m:bg-white tablet-m:flex-row tablet-m:justify-center tablet-m:py-[88px] tablet-m:px-5">
      <FeaturedPostBorderSvg className="left-0 tablet-m:hidden absolute top-0 w-full" />
      <FeaturedPostBorderSvg className="left-0  rotate-180 tablet-m:hidden absolute bottom-0 w-full" />
      <div className="tablet-m:mt-[40px] tablet-m:mr-[68px]">
        <h2 className="max-w-auto text-[32px] mb-8 leading-[40px] mt-5 rotate-[-4deg] tablet-m:max-w-[520px] tablet-m:mt-0 tablet-m:text-[48px] tablet-m:leading-[48px] tablet-m:tracking-[1px] tablet-m:mb-8 font-quirk-bold">
          {title}
        </h2>
        <p className="relative max-w-auto mb-4 rotate-[-2deg] text-[16px] leading-[20px] tablet-m:rotate-[-2deg] tablet-m:max-w-[534px] tablet-m:mb-8 tablet-m:text-[20px] tablet-m:leading-[32px]">
          {htmlToTextTransform(description)}
        </p>
        <SaferDatingButton
          uri={buttonHref}
          forceLang={buttonHrefLang}
          className="rotate-[-2deg]"
        >
          {buttonText}
        </SaferDatingButton>
      </div>
      <div className="rotate-[3.3deg]">
        <img
          className="object-cover object-center w-[499px] h-[249px] tablet-m:w-[665px] tablet-m:h-[420px]"
          style={{
            clipPath: `url(#${ARTICLE_PREVIEW_CLIPPATH_ID})`,
          }}
          width={ResponsiveModel.isMobile ? 499 : 836}
          height={ResponsiveModel.isMobile ? 249 : 423}
          src={imageSrc}
          title={title}
          alt={title}
          draggable={false}
        />
      </div>
    </section>
  )
})
